import request from './request'
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  UserInfo,
} from '@/types/api'

export const authApi = {
  register(data: RegisterRequest) {
    return request.post<unknown, UserInfo>('/api/web/auth/register', data)
  },
  login(data: LoginRequest) {
    return request.post<unknown, LoginResponse>('/api/web/auth/login', data)
  },
  logout() {
    return request.post<unknown, void>('/api/web/auth/logout')
  },
  /**
   * 修改密码。成功后服务端会拉黑当前 token，调用方应清本地登录态 + 跳登录页。
   */
  changePassword(oldPassword: string, newPassword: string) {
    return request.post<unknown, void>('/api/web/auth/change-password', {
      oldPassword,
      newPassword,
    })
  },

  /**
   * 忘记密码：申请重置链接。
   *
   * ⚠️ 后端对「邮箱不存在」也返回成功（防止接口被用来探测哪些邮箱注册过本站）。
   * 所以前端不能提示「该邮箱未注册」，只能统一提示「如果邮箱已注册，链接已发送」。
   */
  forgotPassword(email: string) {
    return request.post<unknown, void>('/api/web/auth/forgot-password', { email })
  },

  /** 校验重置链接是否有效（打开重置页时先调，避免用户填完密码才发现链接过期）。 */
  verifyResetToken(token: string) {
    return request.get<unknown, boolean>('/api/web/auth/reset-password/verify', {
      params: { token },
    })
  },

  /** 凭重置链接里的 token 设置新密码。token 用后即失效。 */
  resetPassword(token: string, newPassword: string) {
    return request.post<unknown, void>('/api/web/auth/reset-password', {
      token,
      newPassword,
    })
  },
}
